'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

function getModalSize() {
    var sizeHash = {
        small: ' modal-sm',
        medium: '',
        large: ' modal-lg'
    };

    return sizeHash[this.props.size];
}

function renderModal() {
    var _props = this.props;
    var children = _props.children;
    var isOpen = _props.isOpen;
    var slideRight = _props.slideRight;
    var modalWrapperClassName = 'modal-wrapper' + (slideRight ? ' slide-right' : '');

    if (this.state.isRendered && isOpen) {
        return _react2['default'].createElement(
            'div',
            { className: modalWrapperClassName },
            _react2['default'].createElement('div', { className: 'modal-backdrop-overlay' }),
            _react2['default'].createElement(
                'div',
                { className: 'modal-dialog' + getModalSize.call(this) },
                _react2['default'].createElement(
                    'div',
                    { className: 'modal-content' },
                    children
                )
            )
        );
    }

    return null;
}

exports['default'] = _react2['default'].createClass({
    displayName: 'modal',

    getInitialState: function getInitialState() {
        return {
            isRendered: false
        };
    },

    componentDidMount: function componentDidMount() {
        var _this = this;

        require('../dist/css/modal.css');

        setTimeout(function () {
            _this.setState({
                isRendered: true
            });
        }, 1);
    },

    render: function render() {
        var _props2 = this.props;
        var transitionEnterTimeout = _props2.transitionEnterTimeout;
        var transitionLeaveTimeout = _props2.transitionLeaveTimeout;
        var className = _props2.className;

        return _react2['default'].createElement(
            _reactAddonsCssTransitionGroup2['default'],
            {
                component: 'div',
                className: className,
                transitionName: 'modal',
                transitionEnterTimeout: transitionEnterTimeout,
                transitionLeaveTimeout: transitionLeaveTimeout
            },
            renderModal.call(this)
        );
    }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/deere-ui-modal-core/lib/modal.js
// module id = 1004
// module chunks = 0